module.exports = __webpack_public_path__ + "img/flying mysterious shrine maiden.12ceaa29.png";